export default __webpack_public_path__ + "static/media/cta.786bcd6a.jpg";